'use client';

import React from 'react';
import { Policy } from '@/features/client/Policy/Policy';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';

const PolicyPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="circle">
        <MainSection
          label="Policy"
          title="Privacy and Cookie Policy"
          description=""
        />
      </MainSectionLayout>
      <Section variant="secondary">
        <Container>
          {' '}
          <Policy />
        </Container>
      </Section>{' '}
      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};
export default PolicyPage;
